import React from 'react';
import styled from 'styled-components/macro';
import { Row, Col } from 'antd';

import Heading from 'components/Heading/Heading';
import SuccessImage from './../../images/host-register-success.png';
import Button from 'components/Button/Button';

const MainContainer = styled(Row)`
  padding: 8% 4% !important;
  width: 100%;

  @media (min-width: 992px) {
    padding: 4% 8% !important;
    width: 68%;
  }
`;

const HostRegistrationSuccess = ({ onSuccess, ...props }) => {
  return (
    <MainContainer>
      <Row type="flex" justify="center">
        <Col>
          <img alt="enquiry big email" src={SuccessImage} />
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col>
          <Heading color="darkGrey" size="sub">
            Congratulations!
          </Heading>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col>
          <Heading color="darkGrey" style={{ marginTop: '-16px' }} align="center" size="sub">
            You have successfully registered.
          </Heading>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col span={6} xs={9}>
          <Button onClick={onSuccess} size="large" style={{ width: '100%', marginTop: '24px' }} type="secondary">
            Home
          </Button>
        </Col>
      </Row>
    </MainContainer>
  );
};

export default HostRegistrationSuccess;
